import axios from 'axios';
import { Contract, CreateContractPayload, UpdateContractPayload } from '../types/contract';
import env from '../utils/env'; // Import env
import { getSupabaseClient } from '../config/supabase'; // Import the function to get the client

const API_BASE_URL = `${env.apiUrl}/contracts`; // Use env.apiUrl and specify contracts base

const getAuthHeaders = async (): Promise<Record<string, string>> => {
  const supabase = getSupabaseClient();
  const { data: { session }, error: sessionError } = await supabase.auth.getSession();

  if (sessionError) {
    console.error('Supabase getSession error in contractApiService:', sessionError);
  }

  const token = session?.access_token;
  const headers: Record<string, string> = {};
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  } else {
    console.warn('No Supabase session token found in contractApiService. API requests might be unauthorized.');
  }
  return headers;
};

export const createContract = async (payload: CreateContractPayload): Promise<Contract> => {
  const authHeaders = await getAuthHeaders();
  const response = await axios.post(API_BASE_URL, payload, { headers: authHeaders });
  return response.data;
};

export const getContract = async (id: string): Promise<Contract> => {
  const authHeaders = await getAuthHeaders();
  const response = await axios.get(`${API_BASE_URL}/${id}`, { headers: authHeaders });
  return response.data;
};

export const getContractByShareToken = async (shareToken: string): Promise<Contract> => {
  // This endpoint is public, so no auth headers are needed
  const response = await axios.get(`${env.apiUrl}/contracts/share/${shareToken}`);
  return response.data;
};

export const updateContract = async (id: string, payload: UpdateContractPayload): Promise<Contract> => {
  const authHeaders = await getAuthHeaders();
  const response = await axios.put(`${API_BASE_URL}/${id}`, payload, { headers: authHeaders });
  return response.data;
};

export const fetchAllContracts = async (): Promise<Contract[]> => {
  const authHeaders = await getAuthHeaders();
  const response = await axios.get(API_BASE_URL, { headers: authHeaders });
  return response.data;
};

export const deleteContract = async (id: string): Promise<void> => {
  const authHeaders = await getAuthHeaders();
  await axios.delete(`${API_BASE_URL}/${id}`, { headers: authHeaders });
};
